// Shared PWA install/platform detection, used by both the global
// InstallPrompt banner and any inline install callouts.

export const isStandalonePwa = () =>
  window.matchMedia?.("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

// iOS Safari only — Chrome/Firefox on iOS can't add to home screen, and
// beforeinstallprompt never fires on iOS at all.
export const isIosSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = /iphone|ipad|ipod/i.test(ua);
  const webkit = /webkit/i.test(ua);
  const otherBrowser = /crios|fxios|edgios|opios/i.test(ua);
  return iOS && webkit && !otherBrowser;
};

export const isMobileUserAgent = () =>
  /android|iphone|ipad|ipod/i.test(window.navigator.userAgent);
